import React, { ReactNode, useEffect, useLayoutEffect, useState } from 'react';

import '../Home.scss';
import { Button, ModalHeader, ModalBody, ModalFooter, Dropdown, Surface, Row, Col, Typography, MessageBlockContent, MessageBlock, TextField, LoadingIndicator } from 'cfa-react-components';
import { IMessage, IMessageEvent, IReplay } from 'interfaces';
import { MessageService } from 'services';
import { MessageItem } from '../items/MessageItem';

interface IMessageModalProps {
    selectedReplay: IReplay,
    onHide: () => void,
}

export function MessageModal({ selectedReplay, onHide }: IMessageModalProps) {

    const [initial, setInitial] = useState(true);
    const [loading, setLoading] = useState(true);
    const [warning, setWarning] = useState<string | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const [messages, setMessages] = useState<IMessage[]>([]);

    useEffect(() => {
        if (!initial) return;
        setInitial(false);

        MessageService.subscribe(selectedReplay.replayUUID)
            .then((s) => {

                // handle messages
                s.addEventListener("message", event => {
                    let messageEvent = JSON.parse(event.data) as IMessageEvent;
                    setMessages(prev => [...prev, ...messageEvent.Messages])
                });

                setLoading(false);
            })
            .catch(e => {
                setErrorMessage("Unable to connect to web socket events");
                setLoading(false);
            });
    });
    
    return (<>

        <ModalHeader>
            Viewing Messages
        </ModalHeader>

        <ModalBody className='messageEvents_modalBody'>
            {warning && (<Row style={{justifyContent: 'center'}}>
                <MessageBlock severity='warning'>
                    <MessageBlockContent>{warning.toString()}</MessageBlockContent>
                </MessageBlock>
            </Row>)}
            {errorMessage && (<Row style={{justifyContent: 'center'}}>
                <MessageBlock severity='error'>
                    <MessageBlockContent>{errorMessage.toString()}</MessageBlockContent>
                </MessageBlock>
            </Row>)}
            <div className="messageEvents">
                {messages.length > 0 ? messages.map(message => (
                    <MessageItem key={message.messageUUID} message={message}/>
                )) : "Waiting for messages..."}
            </div>
        </ModalBody>

        <ModalFooter>
            <Button variant="outlined" onClick={onHide}>
                Close
            </Button>
        </ModalFooter>

    </>);
}